// API URL configuration
// For Cloudflare Pages deployment, use relative URLs
// The functions are served from the same domain under /api

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Stripe publishable key (safe to expose in frontend)
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  'pk_test_51T4Uw5FlOSDEdcgbzU2jJc2CQQ8ojpgtx34uiUDwmLMjLoVaxxb53uqVDRRFrsa1uOxm88VN5Q1SB3zmNz0DbY4m00cNEo2cFn';

export default API_URL;
